import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withKeys as _withKeys } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "login-page-container-center-img"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "login-page-title" }
const _hoisted_6 = {
  key: 1,
  class: "register"
}
const _hoisted_7 = { class: "register-prefix" }
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "login-text-feature" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_13 = {
  key: 5,
  class: "login-switch-divider"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "login-switch-divider__line" }, null, -1)
const _hoisted_15 = { class: "login-switch-divider__text" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "login-switch-divider__line" }, null, -1)
const _hoisted_17 = { class: "login-switch-button__group" }
const _hoisted_18 = ["src"]
const _hoisted_19 = {
  key: 3,
  class: "login-page-footer"
}

import { computed, PropType, ref, nextTick, onActivated } from 'vue';
import { Menu as AMenu, MenuItem as AMenuItem, Dropdown as ADropdown } from 'ant-design-vue';
import { UserOutlined, LockOutlined } from '@ant-design/icons-vue';

import { OioLoginThemeName, OioLoginLogoPosition, getCopyrightStatus, OioLoginThemeConfig, genStaticPath, translateValueByKey } from '@kunlun/dependencies';
import { LoginMode, LoginData, RuntimeLanguage } from '@kunlun/dependencies';
import { OioForm, OioButton, OioFormItem, OioInput, OioIcon, VIDEO_SUFFIX_LIST } from '@kunlun/vue-ui-antd';


export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  props: {
  login: { type: Function as PropType<() => void>, required: true },
  year: { type: [Number, String], required: true },
  gotoForget: { type: Function as PropType<() => void>, required: true },
  getCode: { type: Function as PropType<() => void>, required: true },
  canClick: { type: Boolean, required: true },
  buttonContent: { type: String, required: true },
  loginBlur: { type: Function as PropType<() => void>, required: false },
  clearErrorMessage: { type: Function as PropType<() => void>, required: true },
  authForm: { type: Object as PropType<LoginData>, required: true },
  countryList: { type: Array as PropType<any[]>, required: true },
  error: { type: Object as PropType<LoginData>, required: true },
  setLoginMode: { type: Function as PropType<(mode: LoginMode) => void>, required: true },
  selectCountry: { type: String, required: true },
  searchMethod: { type: Function as PropType<(keyword: string, option: any) => boolean>, required: true },
  handleCountryChange: { type: Function as PropType<(val: string) => void>, required: true },
  graphCode: { type: String, required: true },
  getPicCode: { type: Function as PropType<() => void>, required: true },
  copyrightYear: { type: [Number, String], required: true },
  currentLoginTheme: { type: Object, required: true },
  systemMajorConfig: { type: Object as PropType<Record<string, any>>, required: true },
  handleRegister: { type: Function as PropType<() => void>, required: true },
  loginLabel: { type: String, required: true },
  forgetPassword: { type: Boolean, required: true },
  forgetPasswordLabel: { type: String, required: true },
  register: { type: Boolean, required: true },
  registerLabel: { type: String, required: true },
  codeLogin: { type: Boolean, required: true },
  accountLoginLabel: { type: String, required: true },
  codeLoginLabel: { type: String, required: true },
  accountPlaceholder: { type: String, required: true },
  passwordPlaceholder: { type: String, required: true },
  phonePlaceholder: { type: String, required: true },
  codePlaceholder: { type: String, required: true },
  email: { type: Boolean, required: true },
  emailLoginLabel: { type: String, required: true },
  emailPlaceholder: { type: String, required: true },
  emailCodePlaceholder: { type: String, required: true },
  loginMode: { type: String as PropType<LoginMode>, required: true },
  isAccount: { type: Boolean, required: true },
  isCode: { type: Boolean, required: true },
  isEmail: { type: Boolean, required: true },
  loginModeTitle: { type: String, required: true },
  enableI18n: { type: Boolean },
  languages: { type: Array as PropType<RuntimeLanguage[]>, required: true },
  currentLanguage: { type: Object as PropType<RuntimeLanguage>, required: true },
  onLanguageChange: { type: Function as PropType<(language: RuntimeLanguage) => void>, required: true },
  node_code: String
},
  setup(__props) {

const props = __props



const videoRef = ref<HTMLVideoElement>();

onActivated(() => {
  nextTick(() => {
    if (videoRef.value) {
      videoRef.value.play();
    }
  });
});

/**
 *  有大背景图，并且左侧布局
 */
const useCenteredKeepLeft = {
  justifyContent: 'flex-start',
  paddingLeft: '14%'
};

/**
 *  有大背景图，并且右侧布局
 */
const useCenteredKeepRight = {
  justifyContent: 'flex-end',
  paddingRight: '14%'
};

/**
 * logo的样式
 */
const logoStyle = computed(() => {
  return loginThemeConfig.value.logoPosition === OioLoginLogoPosition.LEFT ? { left: '60px' } : { right: '60px' };
});

/**
 * 背景图
 */
const backgroundImage = computed(() => {
  return loginThemeConfig.value.backgroundImage;
});

/**
 * logo
 */
const loginPageLogo = computed(() => loginThemeConfig.value.logo || '');

/**
 *  当前背景图是不是视频
 */
const isVideoBackground = computed(() => {
  if (backgroundImage.value) {
    const isVideo = !!VIDEO_SUFFIX_LIST.find((suffix) => backgroundImage.value.endsWith(suffix));

    return isVideo;
  }

  return false;
});

/**
 * 默认背景图样式
 */
const useCenteredStyle = computed(() => {
  return {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundImage: isVideoBackground.value ? '' : `url(${backgroundImage.value})`
  };
});

/**
 * 登录页的样式
 */
const loginContainerStyle = computed(() => {
  const { name, backgroundColor } = loginThemeConfig.value;
  let style = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor
  };

  switch (name) {
    case 'CENTER_STICK':
    case 'CENTER_STICK_LOGO':
      style = Object.assign(style, useCenteredStyle.value);
      break;
    case 'LEFT_STICK':
      style = Object.assign(style, useCenteredStyle.value, useCenteredKeepLeft);
      break;
    case 'RIGHT_STICK':
      style = Object.assign(style, useCenteredStyle.value, useCenteredKeepRight);
      break;
    case 'STAND_RIGHT':
      style = Object.assign(style, {
        flexDirection: 'row-Reverse'
      });
      break;
    default:
      break;
  }

  return style;
});

/**
 * logo 是否显示在页面左侧
 */
const logoInLeft = computed(() => {
  return loginThemeConfig.value.logoPosition !== OioLoginLogoPosition.CENTER && loginThemeConfig.value.name !== OioLoginThemeName.CENTER_STICK_LOGO;
});

const isStandLayout = computed(() => {
  return [OioLoginThemeName.STAND_LEFT, OioLoginThemeName.STAND_RIGHT].includes(loginThemeConfig.value.name);
});

/**
 * 登录form表单的样式
 */
const loginBlockStyle = computed(() => {
  const style: Record<string, string> = {};
  const { name } = loginThemeConfig.value;
  if ([OioLoginThemeName.STAND_LEFT, OioLoginThemeName.STAND_RIGHT].includes(name)) {
    style.boxShadow = 'none';
    style.margin = '0 150px';
  }

  return style;
});

/**
 * 登录主题配置
 */
const loginThemeConfig = computed<Required<OioLoginThemeConfig>>(() => {
  const name = props.currentLoginTheme.name || OioLoginThemeName.STAND_RIGHT;
  const defaultImage = [OioLoginThemeName.STAND_LEFT, OioLoginThemeName.STAND_RIGHT].includes(name)
    ? genStaticPath('login_bg_left.jpg')
    : genStaticPath('login_big_image@2x-1.png');

  return {
    name,
    backgroundImage: props.currentLoginTheme.backgroundImage || defaultImage,
    backgroundColor: props.currentLoginTheme.backgroundColor!,
    logo: props.currentLoginTheme.logo,
    logoPosition: props.currentLoginTheme.logoPosition || OioLoginLogoPosition.LEFT
  };
});

const copyrightStatus = getCopyrightStatus();

const copyright = computed(() => {
  return {
    year: props.copyrightYear || '',
    company: props.systemMajorConfig?.partnerName || '',
    icp: props.systemMajorConfig?.icpDesc || ''
  };
});

const onCompanyUrl = () => {
  if (props.systemMajorConfig.officialWebsite) {
    window.open(props.systemMajorConfig.officialWebsite, '_blank');
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input_group = _resolveComponent("a-input-group")!

  return (_openBlock(), _createElementBlock("div", {
    class: "login-page",
    style: _normalizeStyle(_unref(loginContainerStyle)),
    key: __props.node_code
  }, [
    (_unref(isVideoBackground) && !_unref(isStandLayout))
      ? (_openBlock(), _createElementBlock("video", {
          key: 0,
          ref_key: "videoRef",
          ref: videoRef,
          loop: "",
          autoplay: "",
          muted: "",
          class: "login-page-strick-video",
          controls: false,
          src: _unref(backgroundImage)
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true),
    (_unref(logoInLeft))
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "login-page-container-img",
          style: _normalizeStyle(_unref(logoStyle))
        }, [
          (_unref(loginPageLogo))
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _unref(loginPageLogo),
                alt: "logo"
              }, null, 8, _hoisted_2))
            : _createCommentVNode("", true)
        ], 4))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "login-page-container",
      onKeyup: _cache[17] || (_cache[17] = _withKeys(
//@ts-ignore
(...args) => (__props.login && __props.login(...args)), ["enter"])),
      style: _normalizeStyle(_unref(loginBlockStyle))
    }, [
      (!_unref(logoInLeft) && _unref(loginPageLogo))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("img", {
              src: _unref(loginPageLogo),
              alt: "logo"
            }, null, 8, _hoisted_4)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(translateValueByKey)(__props.loginModeTitle)), 1),
      (__props.register)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(translateValueByKey)('没有账号')) + "?", 1),
            _createElementVNode("span", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (__props.handleRegister && __props.handleRegister(...args)))
            }, _toDisplayString(_unref(translateValueByKey)(__props.registerLabel)), 1)
          ]))
        : _createCommentVNode("", true),
      (__props.isAccount)
        ? (_openBlock(), _createBlock(_unref(OioForm), {
            key: 2,
            data: __props.authForm,
            class: "login-page-form"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(OioFormItem), {
                name: "login",
                help: __props.error['login'],
                validateStatus: __props.error['login'] || __props.error['password'] ? 'error' : ''
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(OioInput), {
                    class: "login-input",
                    placeholder: _unref(translateValueByKey)(__props.accountPlaceholder),
                    value: __props.authForm.login,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((__props.authForm.login) = $event)),
                    onBlur: __props.loginBlur,
                    onChange: __props.clearErrorMessage
                  }, {
                    prefix: _withCtx(() => [
                      _createVNode(_unref(UserOutlined))
                    ]),
                    _: 1
                  }, 8, ["placeholder", "value", "onBlur", "onChange"])
                ]),
                _: 1
              }, 8, ["help", "validateStatus"]),
              _createVNode(_unref(OioFormItem), {
                name: "password",
                help: __props.error['password'],
                validateStatus: __props.error['login'] || __props.error['password'] ? 'error' : ''
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input_password, {
                    class: "login-input",
                    placeholder: _unref(translateValueByKey)(__props.passwordPlaceholder),
                    value: __props.authForm.password,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((__props.authForm.password) = $event)),
                    onChange: __props.clearErrorMessage
                  }, {
                    prefix: _withCtx(() => [
                      _createVNode(_unref(LockOutlined))
                    ]),
                    _: 1
                  }, 8, ["placeholder", "value", "onChange"])
                ]),
                _: 1
              }, 8, ["help", "validateStatus"]),
              (__props.graphCode)
                ? (_openBlock(), _createBlock(_unref(OioFormItem), {
                    key: 0,
                    name: "picCode",
                    help: __props.error['picCode'],
                    validateStatus: __props.error['picCode'] ? 'error' : ''
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        class: "login-input",
                        placeholder: _unref(translateValueByKey)('请输入图形验证码'),
                        value: __props.authForm.picCode,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((__props.authForm.picCode) = $event)),
                        onChange: __props.clearErrorMessage
                      }, {
                        prefix: _withCtx(() => [
                          _createVNode(_unref(LockOutlined))
                        ]),
                        suffix: _withCtx(() => [
                          _createElementVNode("img", {
                            src: __props.graphCode,
                            alt: "",
                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (__props.getPicCode && __props.getPicCode(...args)))
                          }, null, 8, _hoisted_8)
                        ]),
                        _: 1
                      }, 8, ["placeholder", "value", "onChange"])
                    ]),
                    _: 1
                  }, 8, ["help", "validateStatus"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["data"]))
        : (__props.isCode)
          ? (_openBlock(), _createBlock(_unref(OioForm), {
              key: 3,
              class: "login-page-form"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(OioFormItem), {
                  name: "phone",
                  help: __props.error['phone'],
                  validateStatus: __props.error['phone'] || __props.error['verificationCode'] ? 'error' : ''
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input_group, { compact: "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          class: "oio-select",
                          "dropdown-class-name": "oio-select-dropdown login-oio-select-dropdown",
                          value: __props.selectCountry,
                          "show-search": "",
                          "filter-option": __props.searchMethod,
                          onChange: __props.handleCountryChange
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.countryList, (country, index) => {
                              return (_openBlock(), _createBlock(_component_a_select_option, {
                                key: index,
                                title: country.phoneCode,
                                value: country.phoneCode
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(country.phoneCode), 1)
                                ]),
                                _: 2
                              }, 1032, ["title", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["value", "filter-option", "onChange"]),
                        _createVNode(_unref(OioInput), {
                          class: "login-input no-margin phone-input",
                          placeholder: _unref(translateValueByKey)(__props.phonePlaceholder),
                          value: __props.authForm.phone,
                          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((__props.authForm.phone) = $event)),
                          onChange: __props.clearErrorMessage
                        }, null, 8, ["placeholder", "value", "onChange"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["help", "validateStatus"]),
                _createVNode(_unref(OioFormItem), {
                  name: "verificationCode",
                  help: __props.error['verificationCode'],
                  validateStatus: __props.error['phone'] || __props.error['verificationCode'] ? 'error' : ''
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input_group, { compact: "" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(OioInput), {
                          class: "login-input no-margin",
                          placeholder: _unref(translateValueByKey)(__props.codePlaceholder),
                          value: __props.authForm.verificationCode,
                          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((__props.authForm.verificationCode) = $event)),
                          onChange: __props.clearErrorMessage
                        }, {
                          suffix: _withCtx(() => [
                            _createVNode(_unref(OioButton), {
                              type: "link",
                              onClick: __props.getCode,
                              disabled: !__props.canClick
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(__props.buttonContent), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick", "disabled"])
                          ]),
                          _: 1
                        }, 8, ["placeholder", "value", "onChange"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["help", "validateStatus"]),
                (__props.graphCode)
                  ? (_openBlock(), _createBlock(_unref(OioFormItem), {
                      key: 0,
                      name: "picCode",
                      help: __props.error['picCode'],
                      validateStatus: __props.error['picCode'] ? 'error' : ''
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          class: "login-input",
                          placeholder: _unref(translateValueByKey)('请输入图形验证码'),
                          value: __props.authForm.picCode,
                          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((__props.authForm.picCode) = $event)),
                          onChange: __props.clearErrorMessage
                        }, {
                          prefix: _withCtx(() => [
                            _createVNode(_unref(LockOutlined))
                          ]),
                          suffix: _withCtx(() => [
                            _createElementVNode("img", {
                              src: __props.graphCode,
                              alt: "",
                              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (__props.getPicCode && __props.getPicCode(...args)))
                            }, null, 8, _hoisted_9)
                          ]),
                          _: 1
                        }, 8, ["placeholder", "value", "onChange"])
                      ]),
                      _: 1
                    }, 8, ["help", "validateStatus"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : (__props.isEmail)
            ? (_openBlock(), _createBlock(_unref(OioForm), {
                key: 4,
                class: "login-page-form"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(OioFormItem), {
                    name: "email",
                    help: __props.error['email'],
                    validateStatus: __props.error['email'] || __props.error['emailCode'] ? 'error' : ''
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(OioInput), {
                        class: "login-input",
                        placeholder: _unref(translateValueByKey)(__props.emailPlaceholder),
                        value: __props.authForm.email,
                        "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((__props.authForm.email) = $event)),
                        onChange: __props.clearErrorMessage
                      }, null, 8, ["placeholder", "value", "onChange"])
                    ]),
                    _: 1
                  }, 8, ["help", "validateStatus"]),
                  _createVNode(_unref(OioFormItem), {
                    name: "emailCode",
                    help: __props.error['emailCode'],
                    validateStatus: __props.error['email'] || __props.error['emailCode'] ? 'error' : ''
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input_group, { compact: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(OioInput), {
                            class: "login-input no-margin",
                            placeholder: _unref(translateValueByKey)(__props.emailCodePlaceholder),
                            value: __props.authForm.emailCode,
                            "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((__props.authForm.emailCode) = $event)),
                            onChange: __props.clearErrorMessage
                          }, {
                            suffix: _withCtx(() => [
                              _createVNode(_unref(OioButton), {
                                type: "link",
                                onClick: __props.getCode,
                                disabled: !__props.canClick
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(__props.buttonContent), 1)
                                ]),
                                _: 1
                              }, 8, ["onClick", "disabled"])
                            ]),
                            _: 1
                          }, 8, ["placeholder", "value", "onChange"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["help", "validateStatus"]),
                  (__props.graphCode)
                    ? (_openBlock(), _createBlock(_unref(OioFormItem), {
                        key: 0,
                        name: "picCode",
                        help: __props.error['picCode'],
                        validateStatus: __props.error['picCode'] ? 'error' : ''
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            class: "login-input",
                            placeholder: _unref(translateValueByKey)('请输入图形验证码'),
                            value: __props.authForm.picCode,
                            "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((__props.authForm.picCode) = $event)),
                            onChange: __props.clearErrorMessage
                          }, {
                            prefix: _withCtx(() => [
                              _createVNode(_unref(LockOutlined))
                            ]),
                            suffix: _withCtx(() => [
                              _createElementVNode("img", {
                                src: __props.graphCode,
                                alt: "",
                                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (__props.getPicCode && __props.getPicCode(...args)))
                              }, null, 8, _hoisted_10)
                            ]),
                            _: 1
                          }, 8, ["placeholder", "value", "onChange"])
                        ]),
                        _: 1
                      }, 8, ["help", "validateStatus"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        (__props.forgetPassword)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "forget",
              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (__props.gotoForget && __props.gotoForget(...args)))
            }, _toDisplayString(_unref(translateValueByKey)(__props.forgetPasswordLabel)), 1))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_unref(OioButton), {
        type: "primary",
        block: "",
        onClick: __props.login
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(translateValueByKey)(__props.loginLabel)), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      (__props.codeLogin || __props.email)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(translateValueByKey)('其他登录方式')), 1),
            _hoisted_16
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_17, [
        (!__props.isAccount)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "login-switch-button",
              onClick: _cache[14] || (_cache[14] = 
            () => {
              __props.setLoginMode(_unref(LoginMode).ACCOUNT);
            }
          )
            }, [
              _createVNode(_unref(OioIcon), {
                icon: "oinone-a-zhanghaodenglu4x",
                size: "14",
                color: "var(--oio-text-color)"
              }),
              _createElementVNode("span", null, _toDisplayString(_unref(translateValueByKey)(__props.accountLoginLabel)), 1)
            ]))
          : _createCommentVNode("", true),
        (!__props.isCode && __props.codeLogin)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "login-switch-button",
              onClick: _cache[15] || (_cache[15] = 
            () => {
              __props.setLoginMode(_unref(LoginMode).CODE);
            }
          )
            }, [
              _createVNode(_unref(OioIcon), {
                icon: "oinone-a-yanzhengmadenglu4x",
                size: "14",
                color: "var(--oio-text-color)"
              }),
              _createElementVNode("span", null, _toDisplayString(_unref(translateValueByKey)(__props.codeLoginLabel)), 1)
            ]))
          : _createCommentVNode("", true),
        (!__props.isEmail && __props.email)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "login-switch-button",
              onClick: _cache[16] || (_cache[16] = 
            () => {
              __props.setLoginMode(_unref(LoginMode).EMAIL);
            }
          )
            }, [
              _createVNode(_unref(OioIcon), {
                icon: "oinone-a-youxiangdenglu4x",
                size: "14",
                color: "var(--oio-text-color)"
              }),
              _createElementVNode("span", null, _toDisplayString(_unref(translateValueByKey)(__props.emailLoginLabel)), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ], 36),
    (_unref(isStandLayout))
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "login-page-ugly-bg",
          style: _normalizeStyle({
        backgroundImage: `url(${_unref(backgroundImage)})`
      })
        }, [
          (_unref(isVideoBackground))
            ? (_openBlock(), _createElementBlock("video", {
                key: 0,
                ref_key: "videoRef",
                ref: videoRef,
                loop: "",
                autoplay: "",
                muted: "",
                class: "login-page-video",
                controls: false,
                src: _unref(backgroundImage)
              }, null, 8, _hoisted_18))
            : _createCommentVNode("", true)
        ], 4))
      : _createCommentVNode("", true),
    (_unref(copyrightStatus))
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("div", null, [
            _createTextVNode(" Copyrights ©" + _toDisplayString(_unref(copyright).year) + " ", 1),
            _createElementVNode("span", {
              style: {"cursor":"pointer"},
              onClick: onCompanyUrl
            }, _toDisplayString(_unref(translateValueByKey)(_unref(copyright).company)), 1)
          ]),
          _createElementVNode("div", null, _toDisplayString(_unref(copyright).icp), 1)
        ]))
      : _createCommentVNode("", true)
  ], 4))
}
}

})